const Americaon2024_2=[
    {
        "type":"Contig",
        "MAX":"221461430",
        "N10":"221461430",
        "N20":"221461430",
        "N30":"117411906",
        "N40":"117411906",
        "N50":"115282544",
        "N60":"101506117",
        "N70":"86824250",
        "N80":"73636471",
        "N90":"62419527",
        "MIN":"59915000"
    },
    {
        "type":"Scaffold",
        "MAX":"221461430",
        "N10":"221461430",
        "N20":"221461430",
        "N30":"117411906",
        "N40":"117411906",
        "N50":"115282544",
        "N60":"101506117",
        "N70":"86824250",
        "N80":"73636471",
        "N90":"62419527",
        "MIN":"59915000"
    }
]
export default Americaon2024_2